import { NestedTreeControl } from '@angular/cdk/tree';
import { Component,OnInit } from '@angular/core';
import { MatDialog, MatTreeNestedDataSource } from '@angular/material';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { GuidanceSearchService } from 'src/app/services/common/guidance-search.service';
import { GuidanceService } from 'src/app/services/http/business/guidance/guidance.service';
import { GuideTreeSearchComponent } from '../guide-tree-search/guide-tree-search.component';

@Component({
  selector: 'app-general-guide',
  templateUrl: './general-guide.component.html',
  styleUrls: ['./general-guide.component.css'],
})
export class GeneralGuideComponent implements OnInit {

  treeControl = new NestedTreeControl<any>(node => node.children);
  dataSource = new MatTreeNestedDataSource<any>();

  selectedGuide: string = "";

  backupGuide: string = "<h4> متاسفانه برای این بخش راهنمایی موجود نمی باشد.</h4>";

  hasChild = (_: number, node: any) => node.HasChild;

  constructor(
    private guideService: GuidanceService,
    private errorService: ErrorsService,
    private dialog: MatDialog,
    private guidanceSearchService: GuidanceSearchService
  ) { }

  ngOnInit() {
    this.getParents();

    // for query
    this.guidanceSearchService.rootCounter$.subscribe((rootObject: any) => {
      if(rootObject.currentLevel == null)
      {
        rootObject.currentLevel = this.dataSource.data;
      }
      const currentLevel = rootObject.currentLevel;
      const node = currentLevel.find((node: any) => node.Id == rootObject.root);

      if(!rootObject.isLast)
      {
        this.onLoadChilds(node, true);
      }else {
        this.onNodeSelect(node);
      }
      
    });
  }

  getParents()
  {
    this.guideService.getParents().subscribe({
      next: (res: any) => {
        this.dataSource.data = res.DataList;
      },
      error: () => {
        this.errorService.transactionError();
      }
    });
  }


  onLoadChilds(node: any, isQuery = false)
  {
    if(node.children != undefined)
    {
      this.treeControl.toggle(node);
      return;
    }

    this.guideService.getChildsByParentId({ParentId: node.Id}).subscribe({
      next: (res: any) => {
        this.attachChildsToNode(node,res.DataList);

        if(isQuery)
        {
          this.guidanceSearchService.onRootResolved(res.DataList);
        }
      },
      error: () => {
        this.errorService.transactionError();
      }
    });
  }

  onNodeSelect(node: any)
  {
    if(node.Description != null)
    {
      this.selectedGuide = node.Description;
    }else{
      this.selectedGuide = this.backupGuide;
    }
    
  }

  private attachChildsToNode(node: any,children: any[])
  {
    node.children = children;

    //trigger change detection
    const tempData = this.dataSource.data;
    this.dataSource.data = null;
    this.dataSource.data = tempData;

    this.treeControl.expand(node);
  }

  onTreeSearch()
  {
    const dialogRef = this.dialog.open(GuideTreeSearchComponent, {
      width: '700px',
    });

    dialogRef.afterClosed().subscribe(x => {
      if(x && x.Id)
      {
        this.getRootList(x);
      }
    });
  }

  getRootList(params: any)
  {
    this.guideService.getRootIdList(params).subscribe({
      next: (res: any) => {
        this.loadChildrenTree(res);
      },
      error: () => {
        this.errorService.transactionError();
      }
    })
  }


  loadChildrenTree(childrenIdList: number[])
  {
    this.guidanceSearchService.setNewRootList(childrenIdList);    
  }

}
